module.exports = __webpack_public_path__ + "img/20191114162050666.b533ecc1.jpg";